const baseForm = {
  employee: {
    name: '',
    employeeCode: null,
    jobTitle: '',
    imgUrl: '',
  },
  client: {
    name: '',
    code: null,
    comercialDivision: null,
  },
  products: [],
  startDate: null,
  endDate: null,
}

export const state = () => ({
  form: baseForm,
  loading: false,
  // possible stages: ['select-products', 'define-values']
  stage: 'select-products',
})

export const mutations = {
  setForm: (state, value) => (state.form = value),
  updateForm: (state, value) => (state.form = { ...state.form, ...value }),
  updateProductQuantity: (state, { code, value }) => {
    const product = state.form.products.find(p => p.code === code)
    if (!product) return
    product.quantity = value
  },
  addProducts: (state, products) => {
    const productsCode = state.form.products.map(item => item.code)
    const productsCodeSet = new Set(productsCode)
    products.forEach(product => {
      if (productsCodeSet.has(product.code)) return
      state.form.products.push({
        ...product,
        quantity: null,
      })
    })
  },
  removeProduct: (state, productCode) => {
    state.form.products = state.form.products.filter(
      p => p.code !== productCode
    )
  },
  setStage: (state, value) => (state.stage = value),
  setLoading: (state, value) => (state.loading = value),
  editStartDate: (state, value) => {
    if (!value) return
    state.form.startDate = value
  },
  editEndDate: (state, value) => {
    if (!value) return
    state.form.endDate = value
  },
}

export const actions = {
  setInitialForm({ commit }, value) {
    commit('updateForm', value)
    commit('setStage', 'define-values')
  },
  configEditFoodSolution({ commit }, form) {
    commit('setForm', { ...form })
    const editabledStatus = ['waiting']
    if (editabledStatus.includes(form.computedStatus)) {
      commit('setStage', 'define-values')
      return $nuxt.$router.push('/food-solution/products')
    }
    return $nuxt.$router.push('/food-solution/view')
  },
  async submitFoodSolution({ dispatch, state }) {
    if (state.form._id) {
      return dispatch('editFoodSolution')
    }
    return dispatch('createFoodSolution')
  },
  async createFoodSolution({ commit, state }) {
    try {
      commit('setLoading', true)
      await this.$axios.post('/v3/app/foodsolution', { ...state.form })
      $nuxt.$router.push('/food-solution')
      commit('setStage', 'select-products')
      commit('setForm', baseForm)
      $nuxt.$notify({
        title: 'Sucesso',
        message: 'Food Solution criado com sucesso',
        type: 'success',
        duration: 2500,
      })
    } catch (error) {
      console.error(error)
      $nuxt.$notify({
        title: 'Erro',
        message: 'Erro ao criar Food Solution',
        type: 'error',
        duration: 2500,
      })
    } finally {
      commit('setLoading', false)
    }
  },
  async editFoodSolution({ commit, state }) {
    try {
      commit('setLoading', true)
      await this.$axios.post(`/v3/app/foodsolution/${state.form._id}`, {
        ...state.form,
      })
      $nuxt.$router.push('/food-solution')
      commit('setStage', 'select-products')
      commit('setForm', baseForm)
      $nuxt.$notify({
        title: 'Sucesso',
        message: 'Food Solution editado com sucesso',
        type: 'success',
        duration: 2500,
      })
    } catch (error) {
      console.error(error)
      const msgs = {
        401: 'Sem autorização',
        403: 'Data limite para edições expirou',
        500: 'Erro desconhecido',
      }
      $nuxt.$notify({
        title: 'Erro',
        message: msgs[error.response.status],
        type: 'error',
        duration: 2500,
      })
    } finally {
      commit('setLoading', false)
    }
  },
}
